import startIntlPhone from '../utils/intl_phone'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

document.addEventListener('turbolinks:load', function () {
  instantiateFlatpickr()
  instantiateBootstrapElements()
  showFlashMessages()
  showPageLoadModals()
  setUpIntlInput()
})

function instantiateFlatpickr() {
  flatpickr('.flatpickr', {
    altInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'Y-m-d',
    disableMobile: true
  })

  flatpickr('.flatpickr-times', {
    altInput: true,
    altFormat: 'F j, Y h:i K', // Display format with time
    dateFormat: 'Y-m-d H:i', // Submission format with time
    enableTime: true, // Enable time selection
    time_24hr: false, // Use 12-hour format
    disableMobile: true
  })

  flatpickr('.flatpickr-inline', {
    altInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'Y-m-d',
    disableMobile: true,
    inline: true,
    minDate: 'today',
    monthSelectorType: 'static'
  })

  flatpickr('.flatpickr-autosave', {
    altInput: true,
    altFormat: 'F j, Y',
    dateFormat: 'Y-m-d',
    disableMobile: true,
    minDate: 'today',
    monthSelectorType: 'static',
    onChange: function (selectedDates, dateStr, instance) {
      let baseUrl = this.element.dataset.url
      window.location.href = `${baseUrl}?date=${dateStr}`
    }
  })

  flatpickr('.flatpickr-multi', {
    altInput: true,
    mode: 'multiple',
    altFormat: 'F j, Y',
    dateFormat: 'Y-m-d',
    minDate: 'today',
    disableMobile: true
  })

  $('.flatpickr-mobile').flatpickr('destroy')
  $('.flatpickr-mobile').remove()
}

function instantiateBootstrapElements() {
  var popoverTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="popover"]')
  )
  var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
    return new bootstrap.Popover(popoverTriggerEl)
  })

  var tooltipTriggerList = [].slice.call(
    document.querySelectorAll('[data-bs-toggle="tooltip"]')
  )
  var tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    var tooltip = new bootstrap.Tooltip(tooltipTriggerEl)
    tooltipTriggerEl.addEventListener('click', function () {
      tooltip.hide()
    })
  })

  var toastElList = [].slice.call(document.querySelectorAll('.toast'))
  var toastList = toastElList.map(function (toastEl) {
    return new bootstrap.Toast(toastEl)
  })
}

function showFlashMessages() {
  var flashSuccess = document.querySelector('.flash-success')
  var successToast = bootstrap.Toast.getInstance(flashSuccess)
  if (flashSuccess != null) {
    successToast.show()
  }

  var flashError = document.querySelector('.flash-error')
  var errorToast = bootstrap.Toast.getInstance(flashError)
  if (flashError != null) {
    errorToast.show()
  }
}

function showPageLoadModals() {
  var modal = document.querySelector('#notificationModal')
  if (modal === null) {
    return false
  }

  var myModal = new bootstrap.Modal(modal, {
    keyboard: false,
    backdrop: 'static'
  })

  myModal.show()
}

function setUpIntlInput() {
  // Inputs with an intl-input-ajax target start their own picker; a second init draws a second flag.
  const input = document.querySelectorAll('.intl-phone:not([data-intl-input-ajax-target])')
  if (input.length == 0) {
    return false
  }

  for (var i = 0; i < input.length; i++) {
    startIntlPhone(input[i])
  }
}
